import Vue from 'vue';
import OnboardingApp from './components/onboarding/OnboardingApp.vue';

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('onboarding-app');
  if (!el) return;

  // Se leen ANTES de montar: Vue reemplaza `el` en el DOM al montar, así que
  // sus data-* atributos ya no existen si se leen dentro de render().
  const props = {
    initialStep: el.dataset.initialStep || 'bienvenida',
    initialNombre: el.dataset.initialNombre || '',
    catalogoUrl: el.dataset.catalogoUrl || '/propiedades',
  };

  new Vue({
    el,
    render: (h) => h(OnboardingApp, { props }),
  });
});
